import "./footer.css";
import ContactMe from "./contact-me/ContactMe";

const Footer = () => (
  <footer>
    <div className="footer-video">
      <video autoPlay loop muted>
        <source src="/assets/videos/video-2.mp4" type="video/mp4" />
      </video>
      <div className="background-overlay"></div>
    </div>
    <ContactMe />
  </footer>
);

export default Footer;
